import { render, staticRenderFns } from "./UpdatePostbackTab.vue?vue&type=template&id=1b4428f7&scoped=true&"
import script from "./UpdatePostbackTab.vue?vue&type=script&lang=ts&"
export * from "./UpdatePostbackTab.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePostbackTab.vue?vue&type=style&index=0&id=1b4428f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4428f7",
  null
  
)

export default component.exports